import { inject, injectable } from "inversify";
import { PlayerControls } from "../../../model/playerConfiguration/PlayerControls";
import { TYPES } from "../../di/types";
import { PlayerContainer } from "../../layer/PlayerContainer";
import { PlayerContainerObserver } from "../../layerObserver/PlayerContainerObserver";

export interface PlayerContainerManager {
  registerObserver(observer: PlayerContainerObserver): void;
  setConfiguration(configuration: PlayerControls): void;
  toggleFullscreen(): void;
  toggleDebugMode(): void;
}

@injectable()
export class PlayerContainerManagerImpl implements PlayerContainerManager {
  constructor(@inject(TYPES.layer.PlayerContainer) private container: PlayerContainer) {}

  registerObserver(observer: PlayerContainerObserver) {
    this.container.registerObserver(observer);
  }

  toggleFullscreen() {
    this.container.toggleFullscreen();
  }

  toggleDebugMode() {
    this.container.toggleDebugMode();
  }

  setConfiguration(configuration: PlayerControls) {
    this.container.setConfiguration(configuration);
  }
}
